/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".municipality-asset-tip-report[_ngcontent-%COMP%]{display:block;width:100%;padding:0;margin:0}"];
export { styles as styles };
